import React from "react";
import { View, Text, TouchableOpacity, Image } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import { AppImages } from "../../utility/AppImages";
import withErrorBoundary from "../../utility/auth/withErrorBoundary";
import { ChatData, useChat } from "../../context/ChatContext";
import Avatar from "../choose-avatar-components/Avatar";

interface ProfileSectionProps {
  selectedName: string;
  item: ChatData;
  selectionMode?: boolean;
  handleCancelSelection?: any;
}

const ChatModalProfileSection: React.FC<ProfileSectionProps> = ({
  selectedName,
  item,
  selectionMode,
  handleCancelSelection,
}) => {
  const styles = useStyles();
  const { userData, userStatuses, setChatVisible } = useChat();

  const displaySelectedName =
    item.type === "single"
      ? item.members.filter(
          (member: string) => member !== userData?.username
        )[0]
      : selectedName;

  const otherMemberStatus =
    item.type === "single" && displaySelectedName
      ? userStatuses[item.conversationId]?.[displaySelectedName] || "offline"
      : null;

  return (
    <View style={{ flexDirection: "row", alignItems: "center" }}>
      <View
        style={{
          backgroundColor: AppColors.purpleColor_9D2CF5,
          borderRadius: 100,
          marginRight: 10,
          alignSelf: "center",
        }}
      >
        <Avatar variant="chatAvatar" src={item.profilePicture} />
      </View>

      <View style={styles.profileTextWrapper}>
        <Text style={[AppFontStyle.BOLD_ANYBODY_16, { paddingBottom: 5 }]}>
          {displaySelectedName}
        </Text>
        {otherMemberStatus && (
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_12,
              {
                color:
                  otherMemberStatus === "online"
                    ? AppColors.green_3D985E
                    : AppColors.white_B7C0CD,
              },
            ]}
          >
            {otherMemberStatus.charAt(0).toUpperCase() +
              otherMemberStatus.slice(1)}
          </Text>
        )}
      </View>
      {selectionMode ? (
        <TouchableOpacity onPress={handleCancelSelection}>
          <Text style={AppFontStyle.REGULAR_ANYBODY_16}>Cancel</Text>
        </TouchableOpacity>
      ) : (
        <TouchableOpacity
          onPress={() => setChatVisible(false)}
          style={styles.closeButton}
        >
          <Image
            source={AppImages.icCancel}
            style={styles.closeIcon}
            resizeMode="contain"
          />
        </TouchableOpacity>
      )}
    </View>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    profilePic: {
      backgroundColor: AppColors.purpleColor_9D2CF5,
      width: 42,
      height: 42,
      borderRadius: 100,
    },
    profileTextWrapper: {
      alignSelf: "center",
      paddingHorizontal: 5,
      flex: 1,
    },

    closeButton: {
      borderWidth: 1.8,
      borderColor: AppColors.grayColor_393939,
      borderRadius: 10,
      height: 30,
      width: 30,
    },
    closeIcon: {
      height: 15,
      width: 12,
      alignSelf: "center",
      marginVertical: 7,
      marginTop: 3,
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      profilePic: {
        width: 32,
        height: 32,
      },
      closeButton: {
        height: 25,
        width: 25,
        marginTop: 6,
      },
      closeIcon: {
        height: 14,
        width: 10,
      },
    },
    [DEVICE_SIZES.SM]: {
      profilePic: {
        width: 36,
        height: 36,
      },
      closeButton: {
        height: 27,
        width: 27,
      },
      closeIcon: {
        height: 11,
        width: 11,
      },
    },
    [DEVICE_SIZES.MD]: {
      profilePic: {
        width: 38,
        height: 38,
      },
      closeButton: {
        height: 28,
        width: 28,
      },
      closeIcon: {
        height: 11,
        width: 11,
      },
    },
    [DEVICE_SIZES.LG]: {
      profilePic: {
        width: 40,
        height: 40,
      },
      closeButton: {
        height: 29,
        width: 29,
      },
      closeIcon: {
        height: 11,
        width: 11,
      },
    },
    [DEVICE_SIZES.XL]: {
      profilePic: {
        width: 42,
        height: 42,
      },
      closeButton: {
        height: 30,
        width: 30,
      },
      closeIcon: {
        height: 12,
        width: 12,
      },
    },
  }
);

export default withErrorBoundary(ChatModalProfileSection);
